import React from 'react';

import ComplexPartner from './complexPartner';

const steps = {
	initial: 0,
	documentation: 1,
	set_customer_id: 2,
	set_credentials: 3,
	set_ipad_token: 4,
	set_api_data: 4,
	set_auth_link: 4,
	set_api_mask: 4,
	set_auth_group: 4,
	set_entities: 4,
	link_external_data: 4,
	trigger_synchro: 4,
	success: 4,
};

const Thais = props => {
	return (
		<ComplexPartner
			key_={props.key_}
			index={props.index}
			setBlurBackground={props.setBlurBackground}
			steps={steps}
		/>
	);
};

export default Thais;
